import { graphql } from 'gatsby';
import { StyledIcon } from '@/components/Link/Link.styles';
import { Wrapper, Button } from './ScrollDownForMore.styles';
import { useCallback, useRef } from 'react';

const ScrollDownForMore = ({ scrollDownForMoreElements }: Queries.SCROLL_DOWN_FOR_MOREFragment) => {
  const icon = scrollDownForMoreElements?.icon?.value;
  const hasIcon = !!icon;

  const ref = useRef<HTMLDivElement>(null);

  const handleClick = useCallback(() => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  return (
    <Wrapper ref={ref}>
      <Button onMouseDown={handleClick}>
        {scrollDownForMoreElements.button_text.value}
        {hasIcon && <StyledIcon {...icon} />}
      </Button>
    </Wrapper>
  );
};

export const fragment = graphql`
  fragment SCROLL_DOWN_FOR_MORE on kontent_item_form_scroll_down_for_more {
    scrollDownForMoreElements: elements {
      button_text {
        value
      }
      icon {
        value {
          description
          height
          name
          type
          url
          width
        }
      }
    }
  }
`;

export default ScrollDownForMore;
